<template>
  <div class="bg-white-1 border-beige-10 flex flex-col gap-3 rounded border border-solid p-5">
    <div class="flex items-center justify-between">
      <div class="flex flex-col gap-1">
        <Transition mode="out-in">
          <RfBaseSkeleton v-if="skeleton" height="25" width="189" srLabel="Loading experiments" />
          <h2 v-else class="text-heading-1 text-beige-90">Experiments</h2>
        </Transition>
        <Transition mode="out-in">
          <RfBaseSkeleton v-if="skeleton" class="mt-2" height="20" width="271" />
          <template v-else>
            <div v-if="!experiments.length" class="text-action-buttons text-grey-1">
              No experiments for this prompt yet
            </div>
          </template>
        </Transition>
      </div>
      <Transition mode="out-in">
        <RfBaseSkeleton v-if="skeleton" height="40" width="200" />
        <RfButtonNew
          v-else
          :disabled="disableCreate"
          class="border-beige-90 text-beige-90 fill-beige-90"
          type="quaternary"
          @click="emit('add')"
        >
          <RfAddIcon class="h-6 w-6" /> New Experiment
        </RfButtonNew>
      </Transition>
    </div>
    <RfAlert v-if="!skeleton && paywallMessage" type="warning">{{ paywallMessage }}</RfAlert>
    <Transition mode="out-in">
      <template v-if="!skeleton">
        <div v-if="experiments.length">
          <RfTable class="w-full overflow-auto" :tableData="{ totalCount: experiments.length }">
            <template #thead>
              <tr class="text-body text-black-2">
                <td class="w-36 px-4! pr-2! pl-0!">Status</td>
                <td class="min-w-40 px-4! py-2!">Name</td>
                <td class="w-32 px-4! py-2!">Date</td>
                <td class="w-28 px-4! py-2!">Variations</td>
                <td class="w-28 px-4! py-2! text-right">Users</td>
                <template v-if="!isInvisible">
                  <td class="w-28 px-4! py-2! text-right">Impr.</td>
                  <td class="w-28 px-4! py-2! text-right">Clicks</td>
                </template>
                <td class="w-20 px-4! py-2! text-right">CTR</td>
                <td class="w-30 px-4! py-2! text-right">Last Updated</td>
              </tr>
            </template>
            <template #tbody>
              <RfPromptExperimentsRow
                v-for="experiment in [...experiments].reverse()"
                :key="experiment.id"
                :experiment="experiment"
                :disableStatusChange="disableStatusChange"
                :promptId="promptId"
                :appId="appId"
                :isInvisible="isInvisible"
                :hasCustomGoal="hasCustomGoal"
                :customGoalInteraction="customGoalInteraction"
                @status="e => emit('status', e)"
              />
            </template>
          </RfTable>
        </div>
      </template>
    </Transition>
  </div>
</template>

<script setup>
import RfTable from "@/blocks/RfTable/RfTable.vue";
import RfButtonNew from "@/components/buttons/RfButtonNew.vue";
import RfBaseSkeleton from "@/components/skeletons/RfBaseSkeleton.vue";
import RfPromptExperimentsRow from "./RfPromptExperimentsRow.vue";
import RfAddIcon from "@/components/icons/RfAddIcon.vue";
import RfAlert from "@/components/alerts/RfAlert.vue";

const emit = defineEmits(["add", "status"]);
defineProps({
  disableStatusChange: { type: [Boolean, String], default: false },
  disableCreate: { type: [Boolean, String], default: false },
  experiments: { type: Array, default: () => [] },
  promptId: { type: String, default: "" },
  appId: { type: String, default: "" },
  isInvisible: { type: Boolean, default: false },
  hasCustomGoal: { type: Boolean, default: false },
  customGoalInteraction: { type: String, default: "" },
  paywallMessage: { type: String, default: "" },
  skeleton: { type: Boolean, default: false },
});
</script>
